var userId = localStorage.getItem('userId');
if (!userId) {
    userId = 'Anonymous' + guid();
    userId = userId.toString();
    localStorage.setItem('userId', userId);
}

mixpanel.identify(userId);
mixpanel.people.set_once('$first_name', userId);

// Custom function to generate GUIDs
function guid() {
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
        s4() + '-' + s4() + s4() + s4();
}

function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
}